import { Position } from '@softline/application';

export function googleGeolocationLinkFactory(position: Position): string {
  return `https://www.google.com/maps/search/?api=1&query=${position.gpsbreite}%2C${position.gpslaenge}`;
}
